import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedDataService } from '../../shared/shared-data-service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'data-preview-component',
  templateUrl: './data-preview.component.html',
  styleUrls: ['./data-preview.component.scss'],
})
export class DataPreviewComponent implements OnInit, OnDestroy {
  showBackToNewTask = false;
  isStarterUser = false;

  constructor(
    @Optional() public dialogRef: MatDialogRef<DataPreviewComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedData: SharedDataService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.sharedData.getData().subscribe((data) => {
      this.showBackToNewTask = !!data?.fromNewTask;
    });
    this.isStarterUser = (this.authService.userValue as any)?.user_plan === 1;
  }

  closeDialog() {
    this.dialogRef.close();
  }
  
  ngOnDestroy(): void {  
    this.sharedData.setData({ fromNewTask: false });
  }
}
